import { PieChart } from '@mui/x-charts/PieChart';
import { Box, Typography } from '@mui/material';

const valueFormatter = (item: { value: number }) => `${item.value}%`;

type PieItem = { label: string; value: number; color: string };

export default function OrderStatusGraph({ data }: { data: PieItem[] }) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
      <PieChart
        series={[
          {
            data,
            highlightScope: { fade: 'global', highlight: 'item' },
            faded: { innerRadius: 30, additionalRadius: -30, color: 'gray' },
            valueFormatter,
            innerRadius: 60,
            outerRadius: 100,
            paddingAngle: 2,
            cornerRadius: 5,
          },
        ]}
        height={250}
        width={250}
      />
      <Box sx={{ mt: 2 }}>
        <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 1 }}>
          Order Status
        </Typography>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
          {data.map((item, index) => (
            <Box key={index} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Box
                sx={{
                  width: 12,
                  height: 12,
                  backgroundColor: item.color,
                  borderRadius: '2px',
                }}
              />
              <Typography variant="body2" sx={{ minWidth: 80 }}>
                {item.label}:
              </Typography>
              <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                {item.value}%
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
} 